<script setup>
import WhatsAppTemplateParser from 'dashboard/components-next/whatsapp/WhatsAppTemplateParser.vue';
import { ref } from 'vue';

defineProps({
  template: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(['sendMessage', 'replaceMessage', 'validationChange']);

const parserRef = ref(null);

defineExpose({
  sendMessage: () => parserRef.value?.sendMessage(),
  replaceMessage: () => parserRef.value?.replaceMessage(),
});

const handleSendMessage = payload => {
  emit('sendMessage', payload);
};

const handleReplaceMessage = payload => {
  emit('replaceMessage', payload);
};
</script>

<template>
  <div class="flex flex-col gap-4 px-4 pt-6 pb-3 items-start w-full">
    <div class="w-full">
      <WhatsAppTemplateParser
        ref="parserRef"
        :template="template"
        @send-message="handleSendMessage"
        @replace-message="handleReplaceMessage"
        @validation-change="emit('validationChange', $event)"
      />
    </div>
  </div>
</template>
